<template>
  <div class="content">
    <div class="container-fluid">
      <div class="wolt-location-wrapper">
        <location-form v-if="route" :route="route" />
      </div>
    </div>
  </div>
</template>

<script>
import LocationForm from './LocationForm.vue'

export default {
  name: 'LocationEditWolt',
  components: {
    LocationForm
  },
  data () {
    return {
      route: null
    }
  },
  created () {
    // Extract the location ID from the route params
    const locationId = this.$route.params.id

    // Create a route object compatible with LocationForm
    this.route = {
      params: {
        id: locationId
      }
    }

    // Log for debugging purposes
    console.log('Wolt Location Edit page loaded with ID:', locationId)

    // Listen for the close-modal event and handle it as a navigation back
    this.$bus.$on('close-modal', this.handleBackButton)
  },
  beforeDestroy () {
    // Clean up event listener
    this.$bus.$off('close-modal', this.handleBackButton)
  },
  methods: {
    handleBackButton () {
      // Navigate to settings/locations page
      this.$router.push('/settings/locations')
    }
  }
}
</script>

<style scoped>
.wolt-location-wrapper {
  width: 100%;
  min-height: 100vh;
  padding: 20px 0;
}

/* Override any modal-specific styles */
.wolt-location-wrapper >>> .company-details {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Locations/LocationEditWolt.vue